import { useContext } from "react";

import { ModalContext } from "@src/modules/shared/components/Modal/ModalContext";

const useModal = () => useContext(ModalContext);

export default useModal;
